function initializeCollapseTable(container) {
    const button = container.nextElementSibling.querySelector('.cta-collapse');

    if (!button) return;

    button.style.display = 'none';

    const specRows = container.querySelectorAll('.spec-row');
    const initialRows = 5;

    const vehiclesAdded = document.querySelectorAll('[data-vehicle-id]').length;

    /* console.log('Spec rows encontradas:', specRows.length);
    console.log('Vehículos agregados:', vehiclesAdded); */

    if (specRows.length <= initialRows || vehiclesAdded === 0) {
        /* console.log(
            'No hay suficientes filas o no hay vehículos, ocultando botón'
        ); */
        button.style.display = 'none';
        const buttonContainer = button.closest('.cta-see-more');
        if (buttonContainer) {
            buttonContainer.classList.add('hidden');
        }
        return;
    }

    const containerTotalHeight = container.scrollHeight;

    const totalSpecRows = specRows.length;

    if (totalSpecRows > initialRows) {
        const extraRows = totalSpecRows - initialRows;
        const rowHeight = 75;
        const extraHeight = extraRows * rowHeight;

        const initialHeight = containerTotalHeight - extraHeight;

        container.style.height = `${initialHeight}px`;
        container.style.overflow = 'hidden';
        container.style.transition = 'height 0.3s ease-in-out';

        button.style.display = 'block';
        button.textContent = 'Ver Más +';
        /* console.log('Botón de collapse mostrado - Filas:', totalSpecRows); */

        const buttonContainer = button.closest('.cta-see-more');
        if (buttonContainer) {
            buttonContainer.classList.remove('hidden');
        }

        let isExpanded = false;

        button.addEventListener('click', () => {
            if (isExpanded) {
                container.style.height = `${initialHeight}px`;
                button.textContent = 'Ver Más +';
                isExpanded = false;
            } else {
                container.style.height = `${containerTotalHeight}px`;
                button.textContent = 'Ver Menos -';
                isExpanded = true;
            }
        });
    }
}

const collapseComparativeTables = document.querySelectorAll(
    '.collapse-table-comparative'
);

collapseComparativeTables.forEach((container) => {
    initializeCollapseTable(container);
});

window.initializeCollapseTable = initializeCollapseTable;
